import React, { useRef } from 'react';
import { Plus16 } from 'shared/assets/icons';
import { LifeAreaContextMenu } from 'shared/components/connected/life-area-context-menu';
import { IconButton, Sizes } from 'shared/components/ui/icon-button';
import { LifeAreaSideMenuItem } from 'shared/components/ui/life-area-side-menu-item';
import { useOpenCreateTask } from 'shared/contexts/task-detail';
import { useOpenMenu } from 'shared/hooks/use-open-menu';
import { LifeArea } from 'shared/types/life-area';

export type LifeAreaSideNavigationItemProps = {
  lifeArea: LifeArea;
  currentPath?: string;
  isMoving?: boolean;
};

export const LifeAreaSideNavigationItem: React.FC<
  LifeAreaSideNavigationItemProps
> = ({ lifeArea, currentPath, isMoving }) => {
  const containerRef = useRef<HTMLAnchorElement>(null);
  const { menuOpen, openContextMenu, closeMenu } = useOpenMenu();
  const openCreateTask = useOpenCreateTask();
  const isFrozen = !!lifeArea.frozenAt;

  const onCreateTask = (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    openCreateTask({ lifeAreaId: lifeArea.id });
  };

  return (
    <>
      <LifeAreaSideMenuItem
        ref={containerRef}
        lifeArea={lifeArea}
        currentPath={currentPath}
        isMoving={isMoving}
        onContextMenu={isFrozen ? undefined : openContextMenu}
        action={
          <IconButton onClick={onCreateTask} icon={Plus16} size={Sizes.Small} />
        }
      />

      {menuOpen && (
        <LifeAreaContextMenu
          lifeArea={lifeArea}
          onClose={closeMenu}
          referenceElement={containerRef}
        />
      )}
    </>
  );
};
